(function () {
  const root = document.getElementById("hybrid-system-builder-root");
  if (!root) return;
  if (root.dataset.inited === "1") return;
  root.dataset.inited = "1";

  // ---------- Config ----------
  const LENGTHS_ALLOWED = [16, 25, 35, 50, 66, 75];
  const MAX_SATS = 3;

const HANDLES = {
  central24: root.getAttribute("data-central-24"),
  central36: root.getAttribute("data-central-36"),
  wall: root.getAttribute("data-wall"),
  cassette: root.getAttribute("data-cassette"),
  linesetSmall: root.getAttribute("data-lineset-small"),
  linesetMedium: root.getAttribute("data-lineset-medium"),
  linesetLarge: root.getAttribute("data-lineset-large"),
  condenser: root.getAttribute("data-condenser"),
};

console.log("DATASET keys:", Object.keys(root.dataset));
console.log("HANDLES:", HANDLES);
  // ---------- State ----------
  const state = {
    centralBTU: 24000,
    centralLinesetVariantId: null,
    includeCondenser: true,
    sats: [],
    condenserVariantId: null,
  };

  // ---------- HTML scaffold (your full markup) ----------
  root.innerHTML = `
  <div class="mrcool-builder-wrapper">
    <div class="mrcool-builder" id="mrcool-hybrid-builder">

      <h1 class="mb-title">MRCOOL DIY Hybrid™ System Builder</h1>

      <p class="mb-sub">
        Choose a <strong>24k or 36k central ducted air handler</strong>,
        then add up to <strong>three</strong> wall or ceiling air handlers.
        The <strong>combined BTUs</strong> determine the required condenser size.
      </p>

      <!-- Step 1: Central -->
      <div class="mb-card">
        <div class="mb-card-h">
          <div class="mb-icon">1</div>
          <div>
            <h2>Central Ducted Air Handler</h2>
            <p>Pick 24k (≈1000 sq ft) or 36k (≈1500 sq ft). Add a line set if needed.</p>
          </div>
        </div>

        <div class="mb-grid-4">
          <label class="mb-input">
            <span class="mb-label">Central Size</span>
            <select id="mb-central">
              <option value="24000">24,000 BTU (24k)</option>
              <option value="36000">36,000 BTU (36k)</option>
            </select>
          </label>

          <div class="mb-central-view">
            <img id="mb-central-img" class="mb-thumb-lg" alt="Central ducted air handler" width="72" height="72"/>
            <a id="mb-central-link" class="mb-btn link" target="_blank" rel="noopener">View Product</a>
          </div>

          <label class="mb-input">
            <span class="mb-label">Central Line Set</span>
            <select id="mb-central-lineset"></select>
          </label>

          <label class="mb-check">
            <input type="checkbox" id="mb-include-condenser" checked>
            <span>Include recommended condenser</span>
          </label>
        </div>

        <div class="mb-variant-row" id="mb-central-variant"></div>
      </div>

      <!-- Step 2: Satellites -->
      <div class="mb-card">
        <div class="mb-card-h">
          <div class="mb-icon">2</div>
          <div>
            <h2>Add Up to 3 Mini–Split Air Handlers</h2>
            <p>
              Choose <strong>Wall</strong> or <strong>Ceiling Cassette</strong>
              and 6k / 9k / 12k / 18k. Each needs its own line set.
            </p>
          </div>
        </div>

        <div id="mb-sat-container"></div>

        <div class="mb-actions">
          <button id="mb-add-sat" class="mb-btn" type="button">+ Add Air Handler</button>
          <div class="mb-hint"><span id="mb-sat-count">0</span>/3 added</div>
        </div>
      </div>

      <!-- Step 3: Summary -->
      <div class="mb-card">
      <div class="mb-card-h">
          <div class="mb-icon">3</div>
          <div>
            <h2>Build Summary</h2>
            
          </div>
        </div>
        <div class="mb-summary">
          <div class="mb-chips" id="mb-chips"></div>
          <div id="mb-cond-wrap" class="mb-cond"></div>
          <div class="mb-gallery" id="mb-gallery"></div>

          <div class="mb-subtotal">
            <div class="mb-subtotal-row">
              <div class="mb-subtotal-title">Estimated Subtotal</div>
              <div class="mb-subtotal-price" id="mb-subtotal"><span class="mb-skel"></span></div>
            </div>

            <div id="mb-stock-note" class="mb-stock-note"></div>

            <div class="mb-cta">
              <button id="mb-add-to-cart" class="mb-btn main-button" type="button">Add Bundle to Cart</button>
              <button id="mb-copy-link" class="mb-btn" type="button">Copy Shareable Link</button>
            </div>

            <div id="mb-cart-status" class="mb-status"></div>
          </div>
        </div>
      </div>

      <p class="mb-foot">
        Tip: Condenser sizing is based on <strong>combined BTUs</strong> (central + satellites), not just zone count.
      </p>

    </div>
  </div>
  `;

  // ---------- DOM ----------
  const elCentral = document.getElementById("mb-central");
  const elCentralImg = document.getElementById("mb-central-img");
  const elCentralLink = document.getElementById("mb-central-link");
  const elCentralLineset = document.getElementById("mb-central-lineset");
  const elCentralVariantRow = document.getElementById("mb-central-variant");
  const elIncludeCondenser = document.getElementById("mb-include-condenser");

  const elSatContainer = document.getElementById("mb-sat-container");
  const elAddSat = document.getElementById("mb-add-sat");
  const elSatCount = document.getElementById("mb-sat-count");

  const elChips = document.getElementById("mb-chips");
  const elCondWrap = document.getElementById("mb-cond-wrap");
  const elGallery = document.getElementById("mb-gallery");
  const elSubtotal = document.getElementById("mb-subtotal");
  const elStockNote = document.getElementById("mb-stock-note");
  const elAddToCart = document.getElementById("mb-add-to-cart");
  const elCopyLink = document.getElementById("mb-copy-link");
  const elCartStatus = document.getElementById("mb-cart-status");

  // ---------- Product cache ----------
  const productCache = new Map(); // handle -> product json

  async function fetchProduct(handle) {
    if (!handle) throw new Error("Missing product handle.");
    if (productCache.has(handle)) return productCache.get(handle);

    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Failed to fetch product: ${handle}`);
    const data = await res.json();
    productCache.set(handle, data);
    return data;
  }

  function money(cents) {
    // basic formatting (Shopify money format varies by theme; keep simple)
    const v = (cents / 100).toFixed(2);
    return `$${v.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
  }

  function parseBTUFromVariantTitle(title) {
    // tries: "6K", "6 k", "6000", "6,000"
    const t = String(title || "").toUpperCase();

    const kMatch = t.match(/(\d{1,3})\s*K/);
    if (kMatch) return parseInt(kMatch[1], 10) * 1000;

    const btuMatch = t.replace(/,/g, "").match(/(\d{4,6})/);
    if (btuMatch) return parseInt(btuMatch[1], 10);

    return null;
  }

  function parseLengthFromVariantTitle(title) {
    // tries: "16", "16'", "16FT", "16 FT"
    const t = String(title || "").toUpperCase();
    const m = t.match(/(\d{2})\s*(?:'|FT|FEET)?\b/);
    if (!m) return null;
    const n = parseInt(m[1], 10);
    return Number.isFinite(n) ? n : null;
  }

 function pickVariantByLength(product, length) {
  const len = Number(length);

  // Shopify product.js structure:
  // product.options = ["Length", ...]
  // variant.option1 / option2 / option3 contain the option values
  const optIndex = product.options?.findIndex((o) => /LENGTH/i.test(o));

  if (optIndex >= 0) {
    const optKey = `option${optIndex + 1}`; // option1, option2, option3

    const match = product.variants.find((v) => {
      const raw = v[optKey];
      if (!raw) return false;
      const n = parseInt(String(raw).replace(/\D/g, ""), 10);
      return n === len;
    });

    if (match) return match;
  }

  // fallback: parse from title
  return product.variants.find((v) => parseLengthFromVariantTitle(v.title) === len) || null;
}


  function getLinesetHandleForBTU(btu) {
    if (btu <= 12000) return HANDLES.linesetSmall;
    if (btu === 18000) return HANDLES.linesetMedium;
    return HANDLES.linesetLarge;
  }

  function getCentralHandle() {
    return state.centralBTU === 36000 ? HANDLES.central36 : HANDLES.central24;
  }

  // ---------- Satellites ----------
  function newSat() {
    return {
      id: cryptoId(),
      type: "wall", // "wall" | "cassette"
      btu: 9000,
      linesetLength: 25,
      ahuVariantId: null,
      linesetVariantId: null,
    };
  }

  function cryptoId() {
    return "sat_" + Math.random().toString(16).slice(2) + "_" + Date.now().toString(16);
  }

  // ---------- Share link ----------
  function encodeStateToUrl() {
    const payload = {
      c: state.centralBTU,
      cl: state.centralLinesetVariantId,
      ic: state.includeCondenser ? 1 : 0,
      s: state.sats.map((z) => ({
        t: z.type,
        b: z.btu,
        l: z.linesetLength,
      })),
    };
    const json = JSON.stringify(payload);
    const b64 = btoa(unescape(encodeURIComponent(json)));
    const url = new URL(window.location.href);
    url.searchParams.set("mb", b64);
    return url.toString();
  }

  function restoreStateFromUrl() {
    const url = new URL(window.location.href);
    const mb = url.searchParams.get("mb");
    if (!mb) return;

    try {
      const json = decodeURIComponent(escape(atob(mb)));
      const payload = JSON.parse(json);

      if (payload?.c === 24000 || payload?.c === 36000) state.centralBTU = payload.c;
      state.includeCondenser = payload?.ic === 1;

      state.sats = Array.isArray(payload?.s)
        ? payload.s.slice(0, MAX_SATS).map((z) => ({
            id: cryptoId(),
            type: z.t === "cassette" ? "cassette" : "wall",
            btu: [6000, 9000, 12000, 18000].includes(z.b) ? z.b : 9000,
            linesetLength: LENGTHS_ALLOWED.includes(z.l) ? z.l : 25,
            ahuVariantId: null,
            linesetVariantId: null,
          }))
        : [];

      // central line set variant id is optional; we will re-pick based on dropdown
      state.centralLinesetVariantId = null;
      state.condenserVariantId = null;
    } catch (e) {
      // ignore
      console.warn("Bad mb state param:", e);
    }
  }

  // ---------- Rendering helpers ----------
  function formatNumber(n) {
  return Number(n).toLocaleString("en-US");
}  

  function setLoadingSubtotal() {
    elSubtotal.innerHTML = `<span class="mb-skel"></span>`;
  }

  function satRowTemplate(sat, wallProduct, cassetteProduct, linesetProduct, options) {
    const btus = options.btus;
    const lengths = options.lengths;

    return `
      <div class="mb-sat mb-card" data-sat-id="${sat.id}">
      <div class="mb-sat-actions">
            <button class="mb-btn mb-sat-remove" type="button">x</button>
          </div>
        <div class="mb-grid-4">
          <label class="mb-input">
            <span class="mb-label">Type</span>
            <select class="mb-sat-type">
              <option value="wall" ${sat.type === "wall" ? "selected" : ""}>Wall Mount</option>
              <option value="cassette" ${sat.type === "cassette" ? "selected" : ""}>Ceiling Cassette</option>
            </select>
          </label>

          <label class="mb-input">
            <span class="mb-label">Size</span>
            <select class="mb-sat-btu">
              ${btus
                .map(
                  (b) =>
                    `<option value="${b}" ${sat.btu === b ? "selected" : ""}>${(b / 1000).toFixed(0)}k</option>`
                )
                .join("")}
            </select>
          </label>
          <label class="mb-input">
            <span class="mb-label">Product</span>
           
            <div class="mb-gallery">
            <div class="mb-gallery-item mb-item">
                <img class="mb-thumb" alt="Air handler" src="${
                (sat.type === "cassette" ? cassetteProduct?.featured_image : wallProduct?.featured_image) || ""
                }" width="64" height="64"/>
                <div class="mb-mini">
                <div class="mb-ititle">${sat.type === "cassette" ? "MRCOOL 5th Gen Multi-Zone Ceiling-Mounted Air Handler" : "MRCOOL 5th Gen Multi-Zone Wall-Mounted Air Handler"} - ${(sat.btu/1000)|0}K BTU</div>
                </div>
          </div>
           
        </div>
        </label>
          <label class="mb-input">
            <span class="mb-label">Line Set Length</span>
            <select class="mb-sat-lineset">
              ${lengths
                .map(
                  (l) =>
                    `<option value="${l}" ${sat.linesetLength === l ? "selected" : ""}>${l} ft</option>`
                )
                .join("")}
            </select>
          </label>

          
        </div>

        
      </div>
    `;
  }

function formatBTU(n) {
  const num = Number(n || 0);
  return num.toLocaleString("en-US");
}

function satellitesBTU() {
  return state.sats.reduce((sum, z) => sum + (Number(z.btu) || 0), 0);
}

function totalSelectedBTU() {
  return (Number(state.centralBTU) || 0) + satellitesBTU();
}

function renderChips() {
  const central = Number(state.centralBTU) || 0;
  const sats = satellitesBTU();
  const total = central + sats;

  elChips.innerHTML = `
    <span class="mb-chip">Central: ${formatBTU(central)} BTU</span>
    <span class="mb-chip">Wall/Ceiling: ${formatBTU(sats)} BTU</span>
    <span class="mb-chip">Total: ${formatBTU(total)} BTU</span>
  `;
}


  function escapeHtml(s) {
    return String(s)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function renderGallery(selectedItems) {
    // selectedItems: {img, title, priceCents}
    elGallery.innerHTML = selectedItems
      .filter((x) => x && x.img)
      .map(
        (x) => `
        <div class="mb-gallery-item mb-item">
          <img class="mb-thumb" src="${x.img}" alt="${escapeHtml(x.title)}" width="64" height="64"/>
          <div class="mb-mini">
            <div class="mb-ititle">${escapeHtml(x.title)}</div>
            <div class="mb-mini-sub">${money(x.priceCents || 0)}</div>
          </div>
        </div>
      `
      )
      .join("");
  }

  function setCentralPreview(product) {
    elCentralImg.src = product?.featured_image || "";
    elCentralLink.href = product?.url || (product ? `/products/${product.handle}` : "#");
    elCentralLink.textContent = "View Product";
  }

  function renderCentralVariantRow(product) {
    const v = product?.variants?.[0];
    if (!v) {
      elCentralVariantRow.innerHTML = "";
      return;
    }
    elCentralVariantRow.innerHTML = `
      <div class="mb-variant">
        <div><strong>${escapeHtml(product.title)}</strong></div>
        <div>${money(v.price)}</div>
      </div>
    `;
  }

  // ---------- Condenser recommendation ----------
  function parseZonesFromCondenserVariantTitle(title) {
    const t = String(title || "");
    const m = t.match(/(\d+)\s*ZONE/i);
    return m ? parseInt(m[1], 10) : null;
  }

  function parseCapacityFromCondenserVariantTitle(title) {
    // Try: "48K", "48000"
    const t = String(title || "").toUpperCase();
    const k = t.match(/(\d{2,3})\s*K/);
    if (k) return parseInt(k[1], 10) * 1000;

    const n = t.replace(/,/g, "").match(/(\d{4,6})/);
    if (n) return parseInt(n[1], 10);

    return null;
  }

  function pickRecommendedCondenserVariant(condenserProduct, requiredZones, requiredBTU) {
    const candidates = condenserProduct.variants
      .map((v) => {
        const zones = parseZonesFromCondenserVariantTitle(v.title) ?? requiredZones; // fallback
        const cap = parseCapacityFromCondenserVariantTitle(v.title) ?? 999999;
        return { v, zones, cap };
      })
      .filter((x) => x.zones >= requiredZones && x.cap >= requiredBTU);

    if (!candidates.length) return null;

    // Choose smallest cap first, then smallest zones
    candidates.sort((a, b) => (a.cap - b.cap) || (a.zones - b.zones));
    return candidates[0].v;
  }

  function totalBTU() {
    const sats = state.sats.reduce((sum, z) => sum + z.btu, 0);
    return state.centralBTU + sats;
  }

  // ---------- Build cart items ----------
  async function buildCartItems() {
    const items = [];

    // Central
    const centralHandle = getCentralHandle();
    const centralProduct = await fetchProduct(centralHandle);
    const centralVariant = centralProduct.variants[0];
    if (!centralVariant) throw new Error("Central variant missing.");
    items.push({ id: centralVariant.id, quantity: 1 });

    // Central line set: use LARGE line set product (best assumption with your settings)
    // If you later want a dedicated central lineset product, add a new setting and swap handle here.
    if (state.centralLinesetVariantId) {
      items.push({ id: state.centralLinesetVariantId, quantity: 1 });
    }

    // Satellites + their line sets
    for (const sat of state.sats) {
      // AHU variant by BTU
      const ahuHandle = sat.type === "cassette" ? HANDLES.cassette : HANDLES.wall;
      const ahuProduct = await fetchProduct(ahuHandle);

      const ahuVariant = ahuProduct.variants.find((v) => parseBTUFromVariantTitle(v.title) === sat.btu);
      if (!ahuVariant) throw new Error(`Missing ${sat.type} AHU variant for ${(sat.btu/1000)|0}k`);

      items.push({ id: ahuVariant.id, quantity: 1 });

      const lsHandle = getLinesetHandleForBTU(sat.btu);
      const lsProduct = await fetchProduct(lsHandle);
      const lsVariant = pickVariantByLength(lsProduct, sat.linesetLength);
      if (!lsVariant) throw new Error(`Missing line set variant for ${sat.linesetLength}ft`);

      items.push({ id: lsVariant.id, quantity: 1 });
    }

    // Condenser
    if (state.includeCondenser && state.condenserVariantId) {
      items.push({ id: state.condenserVariantId, quantity: 1 });
    }

    return items;
  }

  // ---------- Summary calculation ----------
  async function updateSummary() {
    setLoadingSubtotal();
    elStockNote.textContent = "";
    elCartStatus.textContent = "";

    // Chips
    renderChips();

    // Central product
    const centralProduct = await fetchProduct(getCentralHandle());
    setCentralPreview(centralProduct);
    renderCentralVariantRow(centralProduct);

    // Central line sets dropdown (use large lineset product variants)
    await populateCentralLinesetDropdown();

    // Condenser recommendation
    await recommendCondenser();

    // Prices / gallery / subtotal
    const selectedItems = await collectSelectedItemsForGalleryAndSubtotal();
    renderGallery(selectedItems);

    const subtotal = selectedItems.reduce((sum, x) => sum + (x.priceCents || 0), 0);
    elSubtotal.textContent = money(subtotal);
  }

  async function populateCentralLinesetDropdown() {
    
    // This uses your "large" line set product to populate choices.
    // If central needs different product later, add a central_lineset_handle setting and swap.
    const lsProduct = await fetchProduct(HANDLES.linesetLarge);

    // Build options by allowed lengths and available variants
    const available = LENGTHS_ALLOWED
      .map((len) => {
        const v = pickVariantByLength(lsProduct, len);
        return v ? { len, id: v.id, price: v.price } : null;
      })
      .filter(Boolean);

    // If dropdown already has options with same IDs, keep selection
    const current = state.centralLinesetVariantId;

elCentralLineset.innerHTML = [
  `<option value="">Choose line set length</option>`,
  ...available.map((x) => `<option value="${x.id}">${x.len} ft — ${money(x.price)}</option>`)
].join("");

if (!current) {
  // default to "No line set"
  state.centralLinesetVariantId = null;
} else {
  const ok = available.some((x) => x.id === current);
  if (!ok) state.centralLinesetVariantId = null;
}

elCentralLineset.value = state.centralLinesetVariantId ? String(state.centralLinesetVariantId) : "";
  }

  async function recommendCondenser() {

    const condenserProduct = await fetchProduct(HANDLES.condenser);

    const requiredZones = 1 + state.sats.length;
    const requiredBTU = totalBTU() + 6000;

    const v = pickRecommendedCondenserVariant(condenserProduct, requiredZones, requiredBTU);

    if (!v) {
      state.condenserVariantId = null;
      elCondWrap.innerHTML = `
        <div class="mb-warning">
        Your total (${formatNumber(requiredBTU)} BTU) exceeds largest available condenser (55,000 BTU). Reduce size of mini-splits to match with an available condenser.
        </div>
      `;
      return;
    }

    state.condenserVariantId = v.id;

    const img = condenserProduct.featured_image || "";

    elCondWrap.innerHTML = `
      <div class="mb-cond-rec">
   
        <div class="mb-cond-title"><strong>Recommended Condenser</strong></div>
             <img 
        src="${img}" 
        alt="${escapeHtml(condenserProduct.title)}" 
        class="mb-thumb-lg"
        width="80"
        height="80"
      />
        <div class="mb-cond-sub">${escapeHtml(condenserProduct.title)} — ${escapeHtml(v.title)} (${money(v.price)})</div>
        <a class="mb-btn link" href="/products/${encodeURIComponent(condenserProduct.handle)}" target="_blank" rel="noopener">View Condenser</a>
      </div>
    `;
  }

  async function collectSelectedItemsForGalleryAndSubtotal() {
    const items = [];

    // central
    {
      const p = await fetchProduct(getCentralHandle());
      const v = p.variants[0];
      if (v) items.push({ img: p.featured_image, title: p.title, priceCents: v.price });
    }

    // central lineset (large)
    if (state.centralLinesetVariantId) {
      const p = await fetchProduct(HANDLES.linesetLarge);
      const v = p.variants.find((x) => x.id === state.centralLinesetVariantId);
      if (v) items.push({ img: p.featured_image, title: `${p.title} — ${v.title}`, priceCents: v.price });
    }

    // sats + linesets
    for (const sat of state.sats) {
      const ahuHandle = sat.type === "cassette" ? HANDLES.cassette : HANDLES.wall;
      const ahu = await fetchProduct(ahuHandle);
      const ahuV = ahu.variants.find((v) => parseBTUFromVariantTitle(v.title) === sat.btu);
      if (ahuV) items.push({ img: ahu.featured_image, title: `${ahu.title} — ${ahuV.title}`, priceCents: ahuV.price });

      const lsHandle = getLinesetHandleForBTU(sat.btu);
      const ls = await fetchProduct(lsHandle);
      const lsV = pickVariantByLength(ls, sat.linesetLength);
      if (lsV) items.push({ img: ls.featured_image, title: `${ls.title} — ${lsV.title}`, priceCents: lsV.price });
    }

    // condenser
    if (state.includeCondenser && state.condenserVariantId) {
      const p = await fetchProduct(HANDLES.condenser);
      const v = p.variants.find((x) => x.id === state.condenserVariantId);
      if (v) items.push({ img: p.featured_image, title: `${p.title} — ${v.title}`, priceCents: v.price });
    }

    return items;
  }

  // ---------- Satellites render ----------
  async function renderSats() {
    elSatCount.textContent = String(state.sats.length);
    elAddSat.disabled = state.sats.length >= MAX_SATS;

    if (state.sats.length === 0) {
      elSatContainer.innerHTML = "";
      return;
    }

    // Pre-fetch base products for faster renders (images + variants)
    const wallProduct = await fetchProduct(HANDLES.wall);
    const cassetteProduct = await fetchProduct(HANDLES.cassette);

    // Determine available BTUs from variants (intersection with allowed set)
    const allowedBTUs = [6000, 9000, 12000, 18000];
    const wallBTUs = new Set(wallProduct.variants.map((v) => parseBTUFromVariantTitle(v.title)).filter(Boolean));
    const cassBTUs = new Set(cassetteProduct.variants.map((v) => parseBTUFromVariantTitle(v.title)).filter(Boolean));

    const btus = allowedBTUs.filter((b) => wallBTUs.has(b) || cassBTUs.has(b));

    // We'll populate lengths per sat from its lineset product.
    const rows = [];
    for (const sat of state.sats) {
      const lsHandle = getLinesetHandleForBTU(sat.btu);
      const lsProduct = await fetchProduct(lsHandle);

      const lengths = LENGTHS_ALLOWED.filter((len) => pickVariantByLength(lsProduct, len));

      rows.push(
        satRowTemplate(sat, wallProduct, cassetteProduct, lsProduct, { btus, lengths })
      );
    }

    elSatContainer.innerHTML = rows.join("");
  }

  // ---------- Events ----------
  elCentral.addEventListener("change", async () => {
    state.centralBTU = parseInt(elCentral.value, 10);
    await updateSummary();
  });

elCentralLineset.addEventListener("change", async () => {
  const val = elCentralLineset.value;
  state.centralLinesetVariantId = val ? parseInt(val, 10) : null;
  await updateSummary();
});


  elIncludeCondenser.addEventListener("change", async () => {
    state.includeCondenser = !!elIncludeCondenser.checked;
    await updateSummary();
  });

  elAddSat.addEventListener("click", async () => {
    if (state.sats.length >= MAX_SATS) return;
    state.sats.push(newSat());
    await renderSats();
    await updateSummary();
  });

  elSatContainer.addEventListener("click", async (e) => {
    const btn = e.target.closest(".mb-sat-remove");
    if (!btn) return;
    const row = e.target.closest("[data-sat-id]");
    if (!row) return;
    const id = row.getAttribute("data-sat-id");
    state.sats = state.sats.filter((z) => z.id !== id);
    await renderSats();
    await updateSummary();
  });

  elSatContainer.addEventListener("change", async (e) => {
    const row = e.target.closest("[data-sat-id]");
    if (!row) return;
    const id = row.getAttribute("data-sat-id");
    const sat = state.sats.find((z) => z.id === id);
    if (!sat) return;

    if (e.target.classList.contains("mb-sat-type")) {
      sat.type = e.target.value === "cassette" ? "cassette" : "wall";
      await renderSats();
      await updateSummary();
      return;
    }

    if (e.target.classList.contains("mb-sat-btu")) {
      sat.btu = parseInt(e.target.value, 10);
      // Keep length but if not available in new lineset product, snap to 25 or first available
      const lsHandle = getLinesetHandleForBTU(sat.btu);
      const lsProduct = await fetchProduct(lsHandle);
      const ok = pickVariantByLength(lsProduct, sat.linesetLength);
      if (!ok) {
        const prefer = pickVariantByLength(lsProduct, 25);
        if (prefer) sat.linesetLength = 25;
        else {
          const first = LENGTHS_ALLOWED.find((l) => pickVariantByLength(lsProduct, l));
          sat.linesetLength = first || 25;
        }
      }

      await renderSats();
      await updateSummary();
      return;
    }

    if (e.target.classList.contains("mb-sat-lineset")) {
      sat.linesetLength = parseInt(e.target.value, 10);
      await updateSummary();
      return;
    }
  });

  elAddToCart.addEventListener("click", async () => {
    try {
      elCartStatus.textContent = "Adding bundle to cart…";
      elAddToCart.disabled = true;

      const items = await buildCartItems();

      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ items }),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "Cart add failed.");
      }

      elCartStatus.textContent = "Added! Redirecting to cart…";
      window.location.href = "/cart";
    } catch (err) {
      console.error(err);
      elCartStatus.textContent = "Could not add bundle. Please try again.";
      elAddToCart.disabled = false;
    }
  });

  elCopyLink.addEventListener("click", async () => {
    try {
      const url = encodeStateToUrl();
      await navigator.clipboard.writeText(url);
      elCartStatus.textContent = "Shareable link copied!";
      setTimeout(() => (elCartStatus.textContent = ""), 2200);
    } catch (e) {
      // fallback
      const url = encodeStateToUrl();
      prompt("Copy this link:", url);
    }
  });

  // ---------- Init ----------
  (async function init() {
    restoreStateFromUrl();

    // set UI initial values
    elCentral.value = String(state.centralBTU);
    elIncludeCondenser.checked = !!state.includeCondenser;

    // render sats + summary
    await renderSats();
    await updateSummary();
  })();
})();
